// ============================================================================
// ACTIVITY SELECTION - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'activity-selection',
  name: 'Activity Selection',
  category: 'Greedy',
  complexity: {
    time: 'O(n log n)',
    space: 'O(n)'
  },
  description: 'Activity Selection selects maximum non-overlapping activities using greedy approach. Sorts by finish time and selects activities that dont conflict.'
};
export type MetaType = typeof meta;
